import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import MetaverseClient from 'metaverse-js';

const useWalletAddress = (network: string) => {
	const [address, setAddress] = useState<string | undefined>('');
	const metaverseJs = useSelector(
		(state: RootState) => state.system.metaverseJs
	);
	const [loading, setLoading] = useState(false);
	const getDepositAddress = async (
		metaverseJs: MetaverseClient,
		network: string
	) => {
		try {
			setLoading(true);
			const res = await metaverseJs.getMyAddressDeposit(network);
			setAddress(res);
		} catch (error) {
			console.log('getDepositAddress', error);
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		if (metaverseJs?.tokenId && network) {
			getDepositAddress(metaverseJs, network);
		}
	}, [metaverseJs?.tokenId, network]);

	return {
		address,
		loading,
	};
};

export default useWalletAddress;
